import React, { FC } from 'react';
import { View } from 'react-native';
import { scale } from '@components/frame';
import Separator from '@components/common/Separator';
import { MACHINES_NOW_OVERVIEW_BLOCK_CONFIG } from '@v2/pages/machines/modules/now/components/Overview/constants';
import { BaseTopBlockProps } from '@v2/pages/machines/modules/now/components/Overview/components/TopBlock/types';

const TopBlockSeparator: FC<BaseTopBlockProps> = ({ C }) => {
  const { paddingHorizontal } = MACHINES_NOW_OVERVIEW_BLOCK_CONFIG;

  return (
    <View style={{ paddingHorizontal: scale(paddingHorizontal) }}>
      <Separator C={C} />
    </View>
  );
};

export default TopBlockSeparator;
